import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'name', sortDesc = false, fetchFacets = true) {

    return Api().post('/localities/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  delete_localities(data) {
    return Api().delete('/localities/' + data.localities_id);
  },
  update_localities(data) {
    return Api().post('/localities/' + data.localities_id, qs.stringify({ data: JSON.stringify(data.localities) }));    
  },
  create_localities(data) {
    return Api().post('/localities', qs.stringify({ data: JSON.stringify(data.localities) }));    
  },
  localities(data) {
    return Api().get('/localities/' + data.localities_id);
  }
}